import {
  countriesInfo,
  CountryCode,
  defaultGeoLocationData,
  DialingCode,
} from '../countries';
import { getPhoneUtil } from '../getPhoneUtil';
import { isValidCountryCode } from '../isValidCountryCode';

export const getDialingCodeFromCountryCode = (
  countryCode: string,
  fallBackCountryCode: CountryCode = defaultGeoLocationData.countryCode
) => {
  return isValidCountryCode(countryCode)
    ? countriesInfo[countryCode].dialingCode
    : countriesInfo[fallBackCountryCode].dialingCode;
};

/**
 * Try to get the country dialing code from a phoneNumber, even if it's still incomplete.
 */
export const getDialingCodeFromPhoneNumber = (
  phoneNumber: string,
  fallbackCountryCode: CountryCode = defaultGeoLocationData.countryCode
): DialingCode => {
  const phoneUtil = getPhoneUtil();
  const fallBackDialingCode =
    getDialingCodeFromCountryCode(fallbackCountryCode);

  try {
    const number = phoneUtil.parse(phoneNumber);

    return number.getCountryCode()
      ? (`+${number.getCountryCode()}` as DialingCode)
      : fallBackDialingCode;
  } catch {
    return fallBackDialingCode;
  }
};
